import style from "./MainBlock.module.scss";
import { useStore } from "../../../../stores/use_global_state";
import { useState } from "react";
import AuthModal from "../../../AuthModal/AuthModal";

function MainBlock({ dictionary, mainBlockData, startService }) {
	const [showAuthModal, setShowAuthModal] = useState(false);
	const { state } = useStore();
	const { isAuth } = state;

	return (
		<>
			<section className={style.container}>
				<div className={style.info}>
					<div className={style.text}>
						<h1 className={style.title}>{dictionary[mainBlockData.title] || <div dangerouslySetInnerHTML={{ __html: mainBlockData.title }} />}</h1>
						<p className={style.description}>{dictionary[mainBlockData.description] || mainBlockData.description}</p>
						<button onClick={isAuth ? startService : () => setShowAuthModal(true)} className={style.button}>
							{dictionary["Create"]}
						</button>
					</div>
				</div>
			</section>
			{showAuthModal && <AuthModal closeHandler={() => setShowAuthModal(false)} serviceName="illustratorDrawing" />}
		</>
	);
}

export default MainBlock;
